import ObservationTypes from 'src/utils/ObservationTypes';

export default class ObservationsLogic {
    public getColorFromObservationType(type: string) {
        let color: string;
        if (type === ObservationTypes.Rose) {
            color = 'plum';
        } else if (type === ObservationTypes.Thorn) {
            color = 'cornflowerblue';
        } else if (type === ObservationTypes.Bud) {
            color = 'limegreen';
        } else {
            color = 'black';
        }
        return color;
    }

    public updateCheckboxState(checkBoxes: any, filterFlag: string) {
        checkBoxes[filterFlag] = !checkBoxes[filterFlag];
        return checkBoxes;
    }

    public buildTypeFilter(checkBoxes: any) {
        let filter = '';
        if (checkBoxes.filterByThorn) {
            filter += ObservationTypes.Thorn.toLowerCase() + ' ';
        }
        if (checkBoxes.filterByBud) {
            filter += ObservationTypes.Bud.toLowerCase() + ' ';
        }
        if (checkBoxes.filterByRose) {
            filter += ObservationTypes.Rose.toLowerCase() + ' ';
        }
        return filter;
    }

    public getLabel(label: string) {
        if (label === 'IncludeAllObservers') {
            label = 'Show All Observers';
        }
        return label;
    }
}



// WEBPACK FOOTER //
// ./src/chevrons/behaviors/observations/ObservationsLogic.ts